document.documentElement.classList.add('js');
const mobileMenu = document.querySelector('[data-mobile-menu]');
const menuToggle = document.querySelector('[data-menu-toggle]');
const siteHeader = document.querySelector('[data-site-header]');
const desktopNav = siteHeader?.querySelector('.desktop-nav');
const wordmark = siteHeader?.querySelector('.wordmark');
const headerActions = siteHeader?.querySelector('.header-actions');

const updateHeaderNavigation = () => {
  if (!siteHeader || !desktopNav || !wordmark || !headerActions) return;

  if (window.innerWidth < 768) {
    siteHeader.removeAttribute('data-nav-condensed');
    return;
  }

  // Measure the full navigation first, then collapse only when the three
  // header groups would touch. This also adapts to localization and font changes.
  siteHeader.removeAttribute('data-nav-condensed');
  const logoBounds = wordmark.getBoundingClientRect();
  const navBounds = desktopNav.getBoundingClientRect();
  const actionBounds = headerActions.getBoundingClientRect();
  const safetyGap = 24;
  const hasRoom = navBounds.left >= logoBounds.right + safetyGap
    && navBounds.right <= actionBounds.left - safetyGap;

  siteHeader.toggleAttribute('data-nav-condensed', !hasRoom);
  if (hasRoom) closeMobileMenu();
};

let headerResizeFrame;
window.addEventListener('resize', () => {
  cancelAnimationFrame(headerResizeFrame);
  headerResizeFrame = requestAnimationFrame(updateHeaderNavigation);
});

const closeMobileMenu = () => {
  if (!mobileMenu || !menuToggle) return;
  mobileMenu.removeAttribute('data-open');
  mobileMenu.querySelectorAll('details[open]').forEach((group) => group.removeAttribute('open'));
  menuToggle.setAttribute('aria-expanded', 'false');
};

updateHeaderNavigation();
document.fonts?.ready.then(updateHeaderNavigation);

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-menu-toggle]');
  if (trigger && mobileMenu) {
    const open = mobileMenu.toggleAttribute('data-open');
    trigger.setAttribute('aria-expanded', String(open));
    return;
  }

  if (mobileMenu?.hasAttribute('data-open') && !event.target.closest('.site-header')) closeMobileMenu();
});

mobileMenu?.addEventListener('click', (event) => {
  if (event.target.closest('a')) closeMobileMenu();
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') closeMobileMenu();
});

const closeCurrencySelectors = (except = null) => {
  document.querySelectorAll('[data-currency-selector][open]').forEach((selector) => {
    if (selector !== except) selector.removeAttribute('open');
  });
};

document.querySelectorAll('[data-currency-selector]').forEach((selector) => {
  selector.addEventListener('toggle', () => {
    if (!selector.open) return;
    closeCurrencySelectors(selector);
    selector.querySelector('[data-country-search]')?.focus();
  });
});

document.addEventListener('input', (event) => {
  const search = event.target.closest('[data-country-search]');
  if (!search) return;
  const selector = search.closest('[data-currency-selector]');
  const query = search.value.trim().toLocaleLowerCase();
  let visibleCount = 0;
  selector?.querySelectorAll('[data-country-option]').forEach((option) => {
    const visible = option.dataset.searchValue.includes(query);
    option.hidden = !visible;
    if (visible) visibleCount += 1;
  });
  const empty = selector?.querySelector('[data-country-empty]');
  if (empty) empty.hidden = visibleCount > 0;
});

document.addEventListener('pointerdown', (event) => {
  if (!event.target.closest('[data-currency-selector]')) closeCurrencySelectors();
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const openSelector = document.querySelector('[data-currency-selector][open]');
  if (!openSelector) return;
  openSelector.removeAttribute('open');
  openSelector.querySelector('summary')?.focus();
});

const cartDrawer = document.querySelector('[data-cart-drawer]');
let cartReturnFocus = null;
let cartCloseTimer = null;
let cartOpenAnimation = null;

const formatMoney = (amount, currency = 'USD') => {
  const locale = document.documentElement.lang || 'en-US';
  try {
    return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(amount / 100);
  } catch {
    return `${(amount / 100).toFixed(2)} ${currency}`;
  }
};

const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, (character) => ({
  '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
})[character]);

const setCartBusy = (busy) => {
  if (!cartDrawer) return;
  cartDrawer.toggleAttribute('data-loading', busy);
  cartDrawer.querySelectorAll('button:not([data-cart-close]), input').forEach((control) => {
    control.disabled = busy;
  });
};

const openCart = (trigger) => {
  if (!cartDrawer) return;
  cartReturnFocus = trigger || document.activeElement;
  closeMobileMenu();
  window.clearTimeout(cartCloseTimer);
  cartDrawer.removeAttribute('data-closing');
  if (!cartDrawer.open) {
    cartDrawer.showModal();
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const shell = cartDrawer.querySelector('.cart-drawer__shell');
      cartOpenAnimation?.cancel();
      cartOpenAnimation = shell?.animate(
        [{ transform: 'translateX(100%)' }, { transform: 'translateX(0)' }],
        { duration: 260, easing: 'cubic-bezier(0.32, 0.72, 0, 1)' }
      );
    }
  }
  document.documentElement.classList.add('cart-is-open');
  cartDrawer.querySelector('[data-cart-close]')?.focus();
};

const finishCartClose = () => {
  if (!cartDrawer?.open) return;
  window.clearTimeout(cartCloseTimer);
  cartOpenAnimation?.cancel();
  cartOpenAnimation = null;
  cartDrawer.removeAttribute('data-closing');
  cartDrawer.close();
  document.documentElement.classList.remove('cart-is-open');
  cartReturnFocus?.focus?.();
};

const closeCart = () => {
  if (!cartDrawer?.open || cartDrawer.hasAttribute('data-closing')) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    finishCartClose();
    return;
  }
  cartDrawer.setAttribute('data-closing', '');
  cartCloseTimer = window.setTimeout(finishCartClose, 210);
};

const renderCart = (cart) => {
  if (!cartDrawer) return;
  const items = cartDrawer.querySelector('[data-cart-items]');
  const empty = cartDrawer.querySelector('[data-cart-empty]');
  const footer = cartDrawer.querySelector('[data-cart-footer]');
  const count = cart.item_count || 0;
  const currency = cart.currency || 'USD';

  document.querySelectorAll('[data-cart-count]').forEach((node) => { node.textContent = count; });
  cartDrawer.querySelector('[data-cart-heading-count]').textContent = `(${count})`;
  cartDrawer.querySelector('[data-cart-total]').textContent = formatMoney(cart.total_price, currency);
  empty.hidden = count > 0;
  items.hidden = count === 0;
  footer.hidden = count === 0;

  items.innerHTML = cart.items.map((item) => {
    const key = escapeHtml(item.key);
    const title = escapeHtml(item.product_title);
    const url = escapeHtml(item.url);
    const image = escapeHtml(item.featured_image?.url || item.image || '');
    const imageMarkup = image ? `<img src="${image}" width="120" height="120" alt="">` : '';
    const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<p class="cart-line__variant">${escapeHtml(item.variant_title)}</p>` : '';
    return `<article class="cart-line" data-cart-line data-line-key="${key}">
      <a class="cart-line__image" href="${url}" tabindex="-1" aria-hidden="true">${imageMarkup}</a>
      <div class="cart-line__content"><div class="cart-line__top">
        <a class="cart-line__title" href="${url}">${title}</a>
        <button class="cart-line__remove" type="button" data-cart-remove="${key}" aria-label="Remove ${title}"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 7h14M10 11v6M14 11v6M8 7l1-3h6l1 3M7 7l1 14h8l1-14"/></svg></button>
      </div>${variant}<div class="cart-line__bottom">
        <div class="cart-line__quantity" aria-label="Quantity for ${title}">
          <button type="button" data-cart-quantity="${key}" data-quantity="${item.quantity - 1}" aria-label="Decrease quantity">−</button>
          <span data-line-quantity>${item.quantity}</span>
          <button type="button" data-cart-quantity="${key}" data-quantity="${item.quantity + 1}" aria-label="Increase quantity">+</button>
        </div><span class="cart-line__price">${formatMoney(item.final_line_price, currency)}</span>
      </div></div></article>`;
  }).join('');
};

const addCardProduct = async (button) => {
  const variantId = Number(button.dataset.variantId);
  if (!variantId || button.disabled) return;

  const status = cartDrawer?.querySelector('[data-cart-status]');
  const error = cartDrawer?.querySelector('[data-cart-error]');
  button.disabled = true;
  button.setAttribute('aria-busy', 'true');
  error?.setAttribute('hidden', '');
  openCart(button);
  setCartBusy(true);
  if (status) status.textContent = 'Adding to your cart.';

  try {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    });
    if (!response.ok) throw new Error('Unable to add item');

    const cartResponse = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
    if (!cartResponse.ok) throw new Error('Unable to refresh cart');
    const cart = await cartResponse.json();
    renderCart(cart);
    button.toggleAttribute('data-added', true);
    const label = button.querySelector('[data-card-add-label]');
    if (label) label.textContent = button.dataset.addedLabel || 'Added';
    if (button.dataset.addedAriaLabel) button.setAttribute('aria-label', button.dataset.addedAriaLabel);
    if (status) status.textContent = 'Added to your cart.';
  } catch {
    error?.removeAttribute('hidden');
    if (status) status.textContent = 'We couldn’t add this item. Please try again.';
  } finally {
    setCartBusy(false);
    button.disabled = false;
    button.removeAttribute('aria-busy');
  }
};

const changeCartLine = async (key, quantity) => {
  const error = cartDrawer?.querySelector('[data-cart-error]');
  const status = cartDrawer?.querySelector('[data-cart-status]');
  if (!cartDrawer || !error || !status) return;
  error.hidden = true;
  setCartBusy(true);
  try {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, Number(quantity)) })
    });
    if (!response.ok) throw new Error('Cart update failed');
    const cart = await response.json();
    renderCart(cart);
    status.textContent = quantity > 0 ? 'Cart quantity updated.' : 'Item removed from cart.';
  } catch {
    error.hidden = false;
  } finally {
    setCartBusy(false);
  }
};

document.addEventListener('click', (event) => {
  const cardAdd = event.target.closest('[data-card-add]');
  if (cardAdd) {
    event.preventDefault();
    addCardProduct(cardAdd);
    return;
  }

  const openTrigger = event.target.closest('[data-cart-open]');
  if (openTrigger && cartDrawer) {
    event.preventDefault();
    openCart(openTrigger);
    return;
  }
  if (event.target.closest('[data-cart-close]')) {
    closeCart();
    return;
  }
  const quantity = event.target.closest('[data-cart-quantity]');
  if (quantity) changeCartLine(quantity.dataset.cartQuantity, quantity.dataset.quantity);
  const remove = event.target.closest('[data-cart-remove]');
  if (remove) changeCartLine(remove.dataset.cartRemove, 0);
});

cartDrawer?.addEventListener('click', (event) => {
  if (event.target === cartDrawer) closeCart();
});

cartDrawer?.addEventListener('cancel', (event) => {
  event.preventDefault();
  closeCart();
});

cartDrawer?.addEventListener('close', () => {
  document.documentElement.classList.remove('cart-is-open');
});

document.addEventListener('click', (event) => {
  const thumbnail = event.target.closest('[data-product-thumbnail]');
  if (thumbnail) {
    const mainImage = document.querySelector('[data-product-main-image]');
    if (mainImage && thumbnail.dataset.imageSrc) {
      mainImage.src = thumbnail.dataset.imageSrc;
      mainImage.srcset = '';
      document.querySelectorAll('[data-product-thumbnail]').forEach((button) => {
        const active = button === thumbnail;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
    }
  }

  const quantityButton = event.target.closest('[data-product-quantity-change]');
  if (quantityButton) {
    const input = quantityButton.closest('.product-form')?.querySelector('[data-product-quantity]');
    if (input) input.value = Math.max(1, Number(input.value || 1) + Number(quantityButton.dataset.productQuantityChange));
  }
});

const collectionSortSelect = document.querySelector('[data-collection-sort]');
const setCollectionSortOpen = (open) => {
  collectionSortSelect?.closest('.collection-sort')?.toggleAttribute('data-select-open', open);
};

collectionSortSelect?.addEventListener('pointerdown', () => setCollectionSortOpen(true));
collectionSortSelect?.addEventListener('blur', () => setCollectionSortOpen(false));
collectionSortSelect?.addEventListener('keydown', (event) => {
  if (['ArrowDown', 'ArrowUp', 'Enter', ' '].includes(event.key)) setCollectionSortOpen(true);
  if (['Escape', 'Tab'].includes(event.key)) setCollectionSortOpen(false);
});
document.addEventListener('pointerdown', (event) => {
  if (collectionSortSelect && !event.target.closest('.collection-sort')) setCollectionSortOpen(false);
});

document.addEventListener('change', (event) => {
  const collectionSort = event.target.closest('[data-collection-sort]');
  if (collectionSort) {
    setCollectionSortOpen(false);
    collectionSort.form?.submit();
    return;
  }

  const selector = event.target.closest('[data-product-variant]');
  if (!selector) return;
  const option = selector.selectedOptions[0];
  document.querySelector('[data-product-price]').textContent = option.dataset.price || '';
  const submit = selector.closest('.product-buybox')?.querySelector('[data-product-submit]');
  if (submit) submit.disabled = option.disabled;
});

const collectionFilters = document.querySelector('[data-collection-filters]');
const collectionFilterScrim = document.querySelector('[data-filter-close].collection-filter-scrim');
let collectionFilterReturnFocus = null;
let collectionFilterCloseTimer = null;

const finishCollectionFiltersClose = () => {
  if (!collectionFilters) return;
  window.clearTimeout(collectionFilterCloseTimer);
  collectionFilters.removeAttribute('data-open');
  collectionFilters.removeAttribute('data-closing');
  collectionFilterScrim?.removeAttribute('data-open');
  collectionFilterScrim?.removeAttribute('data-closing');
  document.documentElement.classList.remove('filters-are-open');
  document.querySelector('[data-filter-open]')?.setAttribute('aria-expanded', 'false');
  collectionFilterReturnFocus?.focus?.();
};

const closeCollectionFilters = () => {
  if (!collectionFilters?.hasAttribute('data-open') || collectionFilters.hasAttribute('data-closing')) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    finishCollectionFiltersClose();
    return;
  }
  collectionFilters.setAttribute('data-closing', '');
  collectionFilterScrim?.setAttribute('data-closing', '');
  collectionFilterCloseTimer = window.setTimeout(finishCollectionFiltersClose, 210);
};

document.addEventListener('click', (event) => {
  const openFilters = event.target.closest('[data-filter-open]');
  if (openFilters && collectionFilters) {
    collectionFilterReturnFocus = openFilters;
    window.clearTimeout(collectionFilterCloseTimer);
    collectionFilters.removeAttribute('data-closing');
    collectionFilterScrim?.removeAttribute('data-closing');
    collectionFilters.setAttribute('data-open', '');
    collectionFilterScrim?.setAttribute('data-open', '');
    document.documentElement.classList.add('filters-are-open');
    openFilters.setAttribute('aria-expanded', 'true');
    collectionFilters.querySelector('input:not(:disabled), button')?.focus();
    return;
  }
  if (event.target.closest('[data-filter-close]')) closeCollectionFilters();
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape' && collectionFilters?.hasAttribute('data-open')) closeCollectionFilters();
});

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('[data-product-form]');
  if (!form) return;
  event.preventDefault();
  const submit = form.querySelector('[data-product-submit]');
  const message = form.querySelector('[data-product-message]');
  submit.disabled = true;
  submit.textContent = 'Adding…';
  message.textContent = '';
  try {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    });
    if (!response.ok) throw new Error('Unable to add item');
    const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } });
    const cart = await cartResponse.json();
    renderCart(cart);
    message.textContent = 'Added to your cart.';
    openCart(submit);
  } catch {
    message.textContent = 'We couldn’t add this item. Please try again.';
  } finally {
    submit.disabled = false;
    submit.textContent = 'Add to cart';
  }
});
